// Auto-generated from CSV
export const formDescriptors = {
  Build: [
    "Assembled",
    "Branched",
    "Cohesive",
    "Composite",
    "Crystalline",
    "Dispersed",
    "Framed",
    "Hierarchical",
    "Interconnected",
    "Layered",
    "Modular",
    "Networked",
    "Organized",
    "Reinforced",
    "Segmented",
    "Skeletal",
    "Stacked",
    "Stranded",
    "Supported",
    "Suspended",
    "Tectonic",
    "Trussed",
    "Unitary",
    "Woven",
    "Radial",
    "Monolithic",
    "Interlocking",
    "Cantilevered",
    "Pneumatic",
    "Geodesic",
    "Laminated",
    "Porous",
    "Collapsible",
    "Rigid",
    "Flexible",
    "Expandable",
    "Compact",
    "Disassembled",
    "Stable",
    "Supportive",
    "Braced",
    "Integrated",
    "Hydraulic",
    "Tensioned",
    "Nested",
    "Coiled",
    "Articulated",
    "Partitioned",
    "Compartmentalized",
    "Truss",
    "Honeycomb",
    "Lattice",
    "Strutted",
    "Pivoted",
    "Cavitated",
    "Aggregated",
    "Solid",
    "Hollow",
    "Amorphous",
    "Ribbed",
    "Cabled",
    "Pylon-based",
    "Diaphragmatic",
    "Arched",
    "Vaulted",
    "Pylon",
    "Robust",
    "Delicate",
    "Crude",
    "Refined",
    "Lightweight",
    "Heavy",
    "Durable",
    "Fragile",
    "Seamless",
    "Jointed",
    "Riveted",
    "Welded",
    "Molded",
    "Cast",
    "Forged",
    "Handcrafted",
    "Mass-produced",
    "Precision-engineered",
    "Weathered",
    "Pre-fabricated",
    "Resilient",
    "Sturdy",
    "Heavy-duty",
    "Watertight",
    "Airproof",
    "Heat-resistant",
    "Flame-retardant",
    "Impact-resistant",
    "Sustainable",
    "Recycled",
    "Upcycled",
    "Ergonomic",
    "Weatherproof",
    "Precise",
    "Waterproof",
    "Air-tight",
    "Scratch-resistant",
    "Corrosion-resistant",
    "Bio-degradable",
    "Heavyweight",
    "Brittle",
    "Malleable",
    "Sprawling",
    "Openwork",
    "Substantial",
    "Minimalist",
    "Intricate",
    "Biodegradable",
    "Water-resistant",
    "Vacuum-sealed",
    "Pressure-tested",
    "Finely-tooled",
    "Bio-based",
    "Machined",
    "Flame-resistant",
    "Shatterproof",
    "Eco-friendly",
  ],
  Shape: [
    "Angular",
    "Asymmetrical",
    "Bulbous",
    "Circular",
    "Conical",
    "Cylindrical",
    "Elliptical",
    "Flat",
    "Geometric",
    "Irregular",
    "Linear",
    "Multi-faceted",
    "Oblique",
    "Oval",
    "Parabolic",
    "Polygonal",
    "Rectangular",
    "Rounded",
    "Spherical",
    "Spiral",
    "Square",
    "Tapered",
    "Triangular",
    "Undulating",
    "Volumetric",
    "Cuboid",
    "Ovoid",
    "Curvilinear",
    "Symmetrical",
    "Organic",
    "Amorphous",
    "Pointed",
    "Concave",
    "Convex",
    "Arcuate",
    "Grooved",
    "Notched",
    "Truncated",
    "Oblong",
    "Freeform",
    "Pyramidal",
    "Ellipsoidal",
    "Toroidal",
    "Planar",
    "Biomorphic",
    "Rhomboid",
    "Globular",
    "Sinuous",
    "Fusiform",
    "Lenticular",
    "Crescent",
    "Amorphic",
    "Faceted",
    "Polyhedral",
    "Voluminous",
  ],
  Color: [
    "Chromatic",
    "Bichromatic",
    "Monochromatic",
    "Iridescent",
    "Opaque",
    "Translucent",
    "Transparent",
    "Vibrant",
    "Muted",
    "Pastel",
    "Deep",
    "Light",
    "Pale",
    "Intense",
    "Subdued",
    "Variegated",
    "Gradient",
    "Speckled",
    "Solid",
    "Tinted",
    "Shaded",
    "Glimmering",
    "Reflective",
    "Matte",
    "Glossy",
    "Polychromatic",
    "Saturated",
    "Desaturated",
    "Luminous",
    "Achromatic",
    "Gleaming",
    "Bi-Colored",
    "Neutral",
    "Earthy",
    "Metallic",
    "Fluorescent",
    "Two-toned",
    "Phosphorescent",
    "Spectral",
    "Cool",
    "Warm",
    "Opalescent",
    "Tonal",
    "Duotone",
    "Gradated",
    "Luminescent",
    "Jewel-toned",
    "Glow-in-the-dark",
    "Color-shifting",
  ],
  Aesthetics: [
    "Balanced",
    "Symmetrical",
    "Proportionate",
    "Harmonious",
    "Graceful",
    "Ornate",
    "Understated",
    "Clean",
    "Cluttered",
    "Decorative",
    "Functional",
    "Expressive",
    "Impressive",
    "Striking",
    "Subtle",
    "Refined",
    "Raw",
    "Classic",
    "Modern",
    "Avant-garde",
    "Eclectic",
    "Minimal",
    "Maximal",
    "Sculptural",
    "Picturesque",
    "Artistic",
    "Beautiful",
    "Elegant",
    "Stylish",
    "Exquisite",
    "Tasteful",
    "Contemporary",
    "Minimalist",
    "Rustic",
    "Industrial",
    "Bohemian",
    "Glamorous",
    "Quirky",
    "Unconventional",
    "Attractive",
    "Sleek",
    "Ornamental",
    "Streamlined",
    "Asymmetrical",
    "Retro",
    "Futuristic",
    "Organic",
    "Geometric",
    "Dynamic",
    "Static",
    "Imposing",
    "Polished",
    "Dramatic",
    "Sublime",
    "Unassuming",
    "Delicate",
    "Maximalist",
    "Visually-arresting",
    "Aesthetically-pleasing",
    "Abstract",
    "Visually-appealing",
    "Eye-catching",
    "Grandiose",
    "Playful",
    "Serene",
    "Bold",
    "Intriguing",
    "Comforting",
    "Aggressive",
    "Whimsical",
    "Nostalgic",
    "Luxurious",
    "Energetic",
    "Sophisticated",
    "Austere",
    "Inviting",
    "Threatening",
    "Relaxing",
    "Grounded",
    "Precious",
    "Humble",
    "Exciting",
    "Timeless",
    "Reassuring",
    "Empowering",
    "Soothing",
    "Stimulating",
    "Provocative",
    "Serious",
    "Authoritative",
    "Approachable",
    "Invigorating",
    "Captivating",
    "Enchanting",
    "Uplifting",
    "Edgy",
    "Powerful",
    "Mysterious",
    "Optimistic",
    "Ethereal",
    "Brutal",
    "Intimate",
    "Rebellious",
    "Authentic",
    "Practical",
    "Reliable",
    "Innovative",
  ],
  Ergonomics: [
    "Adaptable",
    "Adjustable",
    "Intuitive",
    "Accessible",
    "Comfortable",
    "Supportive",
    "Contoured",
    "Grippable",
    "Reachable",
    "Responsive",
    "Safe",
    "User-friendly",
    "Well-balanced",
    "Lightweight",
    "Compact",
    "Streamlined",
    "Tactile",
    "Positionable",
    "Maneuverable",
    "Scalable",
    "Customizable",
    "Efficient",
    "Precise",
    "Natural",
    "Adaptive",
    "Posture-correcting",
    "Fatigue-reducing",
    "Grip-enhancing",
    "Weight-balanced",
    "Padded",
    "Breathable",
    "Non-slip",
    "Stable",
    "Balanced",
    "Dampening",
    "Optimized",
    "Strain-reducing",
    "Secure",
    "Practical",
    "Functional",
    "Human-centered",
    "Durable",
    "Grip-friendly",
    "Ventilated",
    "Manageable",
    "Operable",
    "Grip-able",
    "Biomorphic",
    "Dynamic",
    "Effortless",
    "Ergonomically-sound",
    "Strain-relieving",
    "Hand-friendly",
    "Reach-optimized",
    "Cushioned",
    "Flexible",
    "Well-weighted",
    "Motion-optimized",
    "Task-oriented",
  ],
  Interactivity: [
    "Responsive",
    "Interactive",
    "Dynamic",
    "Reactive",
    "Programmable",
    "Sensitive",
    "Intuitive",
    "Automated",
    "Manual",
    "Digital",
    "Analog",
    "Haptic",
    "Auditory",
    "Visual",
    "Tactile",
    "Communicative",
    "Adaptive",
    "Configurable",
    "Modifiable",
    "Connected",
    "Networked",
    "Autonomous",
    "Remote",
    "Synchronized",
    "Engaging",
    "Immersive",
    "Customizable",
    "Collaborative",
    "Sensory",
    "Gesture-controlled",
    "Voice-activated",
    "Touch-sensitive",
    "Context-aware",
    "Predictive",
    "Personalized",
    "Tangible",
    "Audible",
    "Real-time",
    "Simultaneous",
    "Asynchronous",
    "Kinesthetic",
    "Feedback-driven",
    "Smart",
    "Remote-controlled",
    "Animated",
    "Simulated",
    "Augmented",
    "Virtual",
    "Contextual",
    "Manipulable",
    "Simulative",
    "Learning",
    "Controllable",
    "Seamless",
    "Multimodal",
    "Gesture-based",
    "Cognitive",
  ],
  Texture: [
    "Smooth",
    "Rough",
    "Glossy",
    "Matte",
    "Grainy",
    "Bumpy",
    "Porous",
    "Woven",
    "Knitted",
    "Scaly",
    "Furry",
    "Silky",
    "Velvety",
    "Metallic",
    "Glassy",
    "Oily",
    "Dry",
    "Sticky",
    "Coarse",
    "Fine",
    "Embossed",
    "Etched",
    "Polished",
    "Brushed",
    "Textured",
    "Engraved",
    "Sanded",
    "Coated",
    "Laminated",
    "Leathery",
    "Rubbery",
    "Organic",
    "Tactile",
    "Viscous",
    "Gritty",
    "Solid",
    "Hollow",
    "Satin",
    "Velvet",
    "Sandy",
    "Spongy",
    "Iridescent",
    "Pitted",
    "Corrugated",
    "Opaque",
    "Translucent",
    "Transparent",
    "Debossed",
    "Icy",
    "Nubby",
    "Knurled",
    "Abrasive",
    "Grippy",
    "Cool",
    "Warm",
    "Ridged",
    "Mottled",
    "Patinated",
    "Frosted",
  ],
  Composition: [
    "Unified",
    "Fragmented",
    "Integrated",
    "Juxtaposed",
    "Overlapping",
    "Assembled",
    "Deconstructed",
    "Layered",
    "Stacked",
    "Grouped",
    "Scattered",
    "Concentric",
    "Radial",
    "Linear",
    "Grid-like",
    "Organic",
    "Geometric",
    "Abstract",
    "Representational",
    "Minimalist",
    "Complex",
    "Simple",
    "Dynamic",
    "Static",
    "Ordered",
    "Homogeneous",
    "Heterogeneous",
    "Nested",
    "Clustered",
    "Symmetrical",
    "Asymmetrical",
    "Centralized",
    "Decentralized",
    "Modular",
    "Open",
    "Closed",
    "Dense",
    "Sparse",
    "Random",
    "Balanced",
    "Hierarchical",
    "Grid-based",
    "Repetitive",
    "Varied",
    "Aggregated",
    "Dispersed",
    "Cohesive",
    "Chaotic",
    "Maximalist",
    "Textural",
    "Structured",
    "Harmonious",
    "Disproportionate",
    "Exaggerated",
    "Miniature",
    "Monumental",
    "Oversized",
    "Undersized",
    "Scaled",
    "Relative",
    "Consistent",
    "Regular",
    "Irregular",
    "Dominant",
    "Subordinate",
    "Uniform",
    "Graduated",
    "Condensed",
    "Expanded",
    "Compact",
    "Spacious",
    "Proportional",
    "Miniaturized",
    "Inconsistent",
    "Human-scaled",
    "Delicate",
    "Bulky",
    "Voluminous",
    "Proportionate",
    "Expansive",
    "Elongated",
    "Compressed",
    "Subtle",
    "Refined",
    "Crude",
    "Understated",
    "Intimate",
    "Grand",
    "Human-scale",
    "Distorted",
    "Classical",
    "Modern",
    "Slender",
    "Substantial",
    "Minimal",
    "Maximal",
    "Variable",
    "Golden-ratio",
    "Fibonacci",
    "Harmonic",
    "Grandiose",
    "Absolute",
    "Diminutive",
    "Bold",
    "Elegant",
    "Awkward",
    "Imposing",
    "Well-scaled",
    "Over-sized",
    "Under-sized",
    "Modest",
    "Well-proportioned",
  ],
};


// Motion: [
//   "Fluid",
//   "Static",
//   "Kinetic",
//   "Rotational",
//   "Linear",
//   "Oscillating",
//   "Reciprocating",
//   "Pivoting",
//   "Sliding",
//   "Rolling",
//   "Gliding",
//   "Floating",
//   "Suspended",
//   "Balanced",
//   "Stable",
//   "Unstable",
//   "Jerky",
//   "Smooth",
//   "Controlled",
//   "Uncontrolled",
//   "Rhythmic",
//   "Erratic",
//   "Propelled",
//   "Powered",
//   "Stationary",
//   "Dynamic",
//   "Mobile",
//   "Portable",
//   "Rotating",
//   "Translating",
//   "Vibrating",
//   "Articulated",
//   "Folding",
//   "Extending",
//   "Retracting",
//   "Agile",
//   "Aerodynamic",
//   "Hydrodynamic",
//   "Manual",
//   "Automated",
//   "Precise",
//   "Effortless",
//   "Synchronized",
//   "Variable",
//   "Adjustable",
//   "Free-flowing",
//   "Graceful",
//   "Free-moving",
//   "Continuous",
//   "Intermittent",
//   "Cyclic",
//   "Translational",
//   "Reciprocal",
//   "Mechanical",
//   "Dampened",
// ],